const MuiDialog = {
  styleOverrides: {
    paper: {
      // Customize the dialog paper (the white box)
      borderRadius: 12,
      boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
    },
    root: {},
  },
};

export default MuiDialog;
